import Error from '@comp/Error/Error';
import Layout from '@layout/SimpleLayout/SimpleLayout';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const ErrorComponent = () => <Error />;

ErrorComponent.pageInfo = {
  isMWebSupported: true
};

export default ErrorComponent;
ErrorComponent.Layout = Layout;
ErrorComponent.Wrapper = PageReduxProvider;
